import {
	createComment,
	createReply,
	deleteComment,
	editComment,
	getCommentReactionCounts,
	getCommentReactions,
	getCommentsList,
	registerCommentReaction,
	unregisterCommentReaction,
	updateCommentReaction
} from "client/Api/Hub/Events/eventComments";
import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";
import { HubCommentSectionService } from "../../HubCommentSection/HubCommentSection";
import { doesUserHaveAccess, findUsers } from "client/Api/Hub/Events/eventViewer";

export function getEventCommentService(
	eventId: number
): HubCommentSectionService {
	function withEventId<TArgs extends unknown[], TResult>(
		callback: (eventId: number, ...args: TArgs) => Promise<TResult>
	): (...args: TArgs) => Promise<TResult> {
		return (...args: TArgs) => callback(eventId, ...args);
	}

	return {
		createComment: withEventId(createComment),
		createReply: withEventId(createReply),
		deleteComment: withEventId(deleteComment),
		editComment: withEventId(editComment),
		getCommentReactionCounts: withEventId(getCommentReactionCounts),
		getCommentReactions: withEventId(getCommentReactions),
		registerCommentReaction: withEventId(registerCommentReaction),
		unregisterCommentReaction: withEventId(unregisterCommentReaction),
		updateCommentReaction: withEventId(updateCommentReaction),
		doesUserHaveAccess: withEventId(doesUserHaveAccess),
		findUsers: withEventId(findUsers),
		getCommentsList: withEventId(getCommentsList),
		getCommentImageUrl: getEventCommentImageUrl
	};
}

function getEventCommentImageUrl(imageId: string): string {
	return createUrlRelativeToEnvironment(
		`/Hub/Events/Comments/Image/?imageId=${encodeURIComponent(imageId)}`
	);
}
